import profile from "../assets/profile.png";

const testimonials = [
    {
      id: 1,
      name: "Charan’s Parent",
      // role: "Developer",
      image: profile,
      rating: 5,
      treatment: "Occupational Therapy.",
      feedback: "Our son has shown so much improvement since starting therapy. His emotion control and sitting tolerance have really improved. He’s now able to recognize and imitate alphabets, and his hand coordination is much better too.",
    },
    {
      id: 2,
      name: "Rajesh",
      // role: "UI/UX Designer",
      image: profile,
      rating: 4,
      treatment: "Occupational Therapy",
      feedback: "We noticed that since therapy began, his physical structure and ability to pick up objects have improved a lot. Recognizing and arranging objects like alphabet pegs and fruits has become easy for him.",
    },
    {
      id: 3,
      name: "Abhay’s Parents",
      // role: "Software Engineer",
      image: profile,
      rating: 3,
      treatment: "Speech Therapy",
      feedback: "Abhay’s behavior and emotional control have transformed remarkably. He expresses himself clearly and manages his anger much better. Writing skills have improved too — we were thrilled to see him write neatly and focus for longer periods.",
    },
    {
      id: 4,
      name: "Karthik",
      // role: "Software Engineer",
      image: profile,
      rating: 5,
      treatment: "Speech Therapy",
      feedback: "The behavioral therapists at DBR use very effective, friendly, and strategic methods. Group and one-on-one sessions have helped our son communicate better, resolve issues peacefully, and gain more confidence.",
    },
    {
      id: 5,
      name: "Charan",
      // role: "Software Engineer",
      image: profile,
      rating: 5,
      treatment: "Behavioural Therapy ",
      feedback: "Thanks to the dedication of the entire team, Abhay’s daily living and social skills have come a long way. We are grateful for the staff’s efforts and the safe, caring environment they provide.",
    },
  ];
  
  export default testimonials;
  